import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngxs/store';
import { _debounceDecorator } from '@shared/aux_helper_functions';
import { Router } from '@angular/router';
import { CheckBoxData } from '../model/checkBoxModel';

@Component({
  selector: 'ian-header-masive-action-and-filter-v2',
  templateUrl: './ian-header-masive-action-and-filter.components.html',
  styleUrls: ['./ian-header-masive-action-and-filter.components.scss'],
})
export class IanHeaderMasiveActionAndFilterComponentV2 implements OnInit, OnChanges, OnDestroy {
  @Input('isLoading') isLoading: boolean;
  @Input('buttons') toolbarActionButtons: any;
  @Input('actions') actionToolbarActions: any;
  @Input('urlScreen') urlScreen: string;
  @Input('showTextSearchInput') showTextSearchInput = true;
  @Input('disableTextSearchInput') disableTextSearchInput = false;
  @Input() checkBoxData: CheckBoxData;
  @Output() actionExecuted: EventEmitter<any> = new EventEmitter();
  @Output() filterSearch: EventEmitter<string> = new EventEmitter();
  @Output() updateInputSearch: EventEmitter<boolean> = new EventEmitter();
  @Output() checkBoxDataOut: EventEmitter<CheckBoxData> = new EventEmitter();

  hasBulkSelection = false;

  selectedItems: Array<any>;

  isBulkSelectionIndetermined: boolean;

  isBulkSelection: boolean;

  totalItemsSelected: number;

  private unsuscribreAll: Subject<void> = new Subject<void>();
  constructor(private store: Store, private router: Router) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['checkBoxData']) {
      if (this.checkBoxData != null) {
        this.hasBulkSelection = this.checkBoxData?.getHasBulkSelection();
        this.totalItemsSelected = this.checkBoxData?.getTotalItemsSelected();
        this.updateInputSearch.emit(this.hasBulkSelection);
      }
    }
  }

  ngOnInit(): void {}

  /**
   * clearSelected se llama solo cuando se quiere limpiar toda la seleccion
   * @returns {void}
   */
  clearSelected(): void {
    this.checkBoxData.resetSelection();
    this.checkBoxDataOut.emit(this.checkBoxData);
  }

  @_debounceDecorator(512)
  onSearch(evt): void {
    this.filterSearch.emit(evt);
  }

  @_debounceDecorator(256)
  executeAction(evt): void {
    this.actionExecuted.emit(evt);
  }

  ngOnDestroy(): void {
    this.unsuscribreAll.next();
    this.unsuscribreAll.complete();
  }
}
